/**
 * Let user confirm a page change if there is a textarea or input field with text
 * listen for clicks on anchor elements that are neither empty ('javascipt:;') nor linking to some bootstrap anchor ('#')
 */
export default {
	achorSelector:
		"a:not([href='javascript:;']):not([href^='#']):not(.j-handling-with-rails)",
	watchedInputFieldSelector:
		"input.j-watched-for-page-change, textarea.j-watched-for-page-change, span.j-watched-for-page-change[contenteditable]",

	init() {
		// Don't include 'span[contenteditable]' in this list, FF doesn't fire a keyup event on it
		$(document).on(
			"keyup",
			"form input:not(.j-no-page-change-confirm), form textarea:not(.j-no-page-change-confirm)",
			({ target, keyCode, ctrlKey }) => {
				const $target = $(target);
				// pp.log("CHANGE PAGE CONFIRM keyup event -- event, target, ctrlKey, keyCode", e, e.target, e.ctrlKey, e.keyCode);

				// Don't do anything if input is hidden (jquery.placeholder changes values in hidden fields on IE)
				// or if this is just the ctrl key (which doesn't write anything)
				// or if this is a ctrl+enter submit call (handled in pp.global.sendMessagesOnEnterListener)
				if (
					$target.attr("type") == "hidden" ||
					keyCode == 17 ||
					(ctrlKey && keyCode == 13)
				) {
					return false;
				}

				// Check for currentActorId to avoid showing confirms in the backend
				if (pp.currentActorId !== undefined && $target.val().length > 0) {
					if (!$target.hasClass("j-watched-for-page-change")) {
						pp.pageChangeConfirm.addListeners($target);
					}
				} else {
					pp.pageChangeConfirm.removeListeners($target);
				}
			},
		);
	},

	addListeners($inputFields) {
		pp.log(
			"CHANGE PAGE CONFIRM adding (if not already in place):",
			$inputFields,
		);
		if (!$(this.watchedInputFieldSelector).length) {
			$(this.achorSelector).on("click", pp.pageChangeConfirm.testLinkForModal);
			$(document).on(
				"page:before-change ajax:beforeSend",
				pp.pageChangeConfirm.cancelLinkExecution,
			);
		}
		$inputFields.addClass("j-watched-for-page-change");

		// account for the scenario where the input field is in an open modal
		$.each($inputFields, function () {
			const $inputField = $(this);
			$inputField.closest("div.modal").one("hidden.bs.modal", () => {
				pp.log(
					"PAGE CHANGE CONFIRM containing modal hidden -- input field:",
					$inputField,
				);
				pp.pageChangeConfirm.removeListeners($inputField);
			});
			$inputField.closest("form").one("submit", () => {
				pp.pageChangeConfirm.removeListeners($inputField);
			});
		});
	},

	removeListeners($inputField) {
		if ($inputField !== undefined && $inputField.length != 0) {
			if ($inputField.hasClass("j-watched-for-page-change")) {
				pp.log(
					"CHANGE PAGE CONFIRM removing -- for field:",
					$inputField[0].attributes,
				);
				$inputField.removeClass("j-watched-for-page-change");
			}
			if ($(this.watchedInputFieldSelector).length == 0) {
				$(this.achorSelector).off(
					"click",
					pp.pageChangeConfirm.testLinkForModal,
				);
				$(document).off(
					"page:before-change ajax:beforeSend",
					pp.pageChangeConfirm.cancelLinkExecution,
				);
			}
		} else {
			pp.log(
				"CHANGE PAGE CONFIRM removing for all -- watched fields:",
				$(this.watchedInputFieldSelector),
			);
			$(this.achorSelector).off("click", pp.pageChangeConfirm.testLinkForModal);
			$(document).off(
				"page:before-change ajax:beforeSend",
				pp.pageChangeConfirm.cancelLinkExecution,
			);
		}
	},

	testLinkForModal(event) {
		pp.log(
			"CHANGE PAGE CONFIRM test link for modal, event, link:",
			event,
			event.target,
		);
		let $link = $(event.target);
		const data = $link.data();
		if ($link.attr("href") === undefined) {
			pp.log(
				"CHANGE PAGE CONFIRM getting new parent link because link has no href attr:",
				$link.parent().closest("[href]"),
			);
			$link = $link.parent().closest("[href]");
		}

		// don't do anything if there is no object to be handled or this link has its own confirm dialog
		if (
			$link.length == 0 ||
			data["confirm"] ||
			pp.pageChangeConfirm.linkClearsSoleWatchedField($link)
		) {
			return;
		}

		// If link exists and is neither ajax POST nor bootstrap toggle link
		if (!data["method"] && !data["toggle"]) {
			pp.pageChangeConfirm.showModal($link);
		} else {
			const $watchedFieldsStash = $(
				pp.pageChangeConfirm.watchedInputFieldSelector,
			);
			pp.log(
				"CHANGE PAGE CONFIRM stashing watched fields, handling links and re-added watched fields, stash:",
				$watchedFieldsStash,
			);
			pp.pageChangeConfirm.removeListeners();
			pp.global.handleRailsLink($link);
			pp.pageChangeConfirm.addListeners($watchedFieldsStash);
		}
	},

	showModal($link) {
		$.confirm({
			text: I18n.t("dialogs.unsaved_changes_confirmation"),
			confirm(button) {
				// pp.log("CHANGE PAGE CONFIRM confirmed from modal");
				pp.pageChangeConfirm.removeListeners();
				pp.global.handleRailsLink($link);
			},
			cancel(button) {
				pp.log("CHANGE PAGE CONFIRM cancel confirm modal");
				// just close the confirm modal
			},
		});
	},

	cancelLinkExecution(event) {
		const $target = $(event.target);
		const data = $target.data();
		pp.log(
			"CHANGE PAGE CONFIRM cancelLinkExecution test -- event, target, data attr:",
			event,
			$target,
			data,
		);
		if ($target.is(pp.pageChangeConfirm.achorSelector)) {
			if (
				data["remote"] !== undefined &&
				!(data["method"] !== undefined && data["confirm"] !== undefined) &&
				!pp.pageChangeConfirm.linkClearsSoleWatchedField($target)
			) {
				return false;
			}
		} else if (event.type === "page:before-change") {
			return false;
		}
	},

	linkClearsSoleWatchedField($link) {
		pp.log(
			"CHANGE PAGE CONFIRM testing if given link clears data of a sole input field, link, result",
			$(pp.pageChangeConfirm.watchedInputFieldSelector),
			$link.data("clearDataButtonFor") &&
				$(pp.pageChangeConfirm.watchedInputFieldSelector).length == 1 &&
				$(pp.pageChangeConfirm.watchedInputFieldSelector)
					.first()
					.is($link.data("clearDataButtonFor")),
		);

		return (
			$link.data("clearDataButtonFor") &&
			$(pp.pageChangeConfirm.watchedInputFieldSelector).length == 1 &&
			$(pp.pageChangeConfirm.watchedInputFieldSelector)
				.first()
				.is($link.data("clearDataButtonFor"))
		);
	},
};
